import {
  Client,
  Vehicle,
  ServiceOrder,
  Mechanic,
  InventoryItem,
  Transaction,
  Appointment,
} from '../lib/types'

export const mockMechanics: Mechanic[] = [
  {
    id: 'm1',
    name: 'Carlos Silva',
    specialty: 'Motor e Câmbio',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Carlos',
  },
  {
    id: 'm2',
    name: 'Roberto Alves',
    specialty: 'Suspensão e Freios',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Roberto',
  },
  {
    id: 'm3',
    name: 'Ana Paula',
    specialty: 'Elétrica e Injeção',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Ana',
  },
]

export const mockClients: Client[] = [
  {
    id: 'c1',
    name: 'João Pereira',
    phone: '11987654321',
    whatsapp: '11987654321',
    email: 'joao.pereira@email.com',
    document: '123.456.789-00',
    address: 'Rua das Flores, 123 - São Paulo, SP',
    createdAt: '2023-01-15T10:00:00Z',
  },
  {
    id: 'c2',
    name: 'Maria Oliveira',
    phone: '11912345678',
    whatsapp: '11912345678',
    email: 'maria.oliveira@email.com',
    document: '987.654.321-11',
    address: 'Av. Paulista, 1000 - São Paulo, SP',
    createdAt: '2023-03-22T14:30:00Z',
  },
  {
    id: 'c3',
    name: 'Empresa Logística SA',
    phone: '1133334444',
    whatsapp: '11933334444',
    email: 'frota@logistica.com.br',
    document: '12.345.678/0001-90',
    address: 'Rodovia Anhanguera, km 15 - Osasco, SP',
    createdAt: '2023-06-10T09:15:00Z',
  },
]

export const mockVehicles: Vehicle[] = [
  {
    id: 'v1',
    clientId: 'c1',
    brand: 'Honda',
    model: 'Civic EXL',
    year: 2019,
    engine: '2.0 16V',
    fuel: 'Flex',
    plate: 'ABC1D23',
    mileage: 45000,
    vin: '93HXXXXXXXXXXXXXX',
    createdAt: '2023-01-15T10:30:00Z',
  },
  {
    id: 'v2',
    clientId: 'c2',
    brand: 'Jeep',
    model: 'Compass Longitude',
    year: 2021,
    engine: '1.3 Turbo',
    fuel: 'Flex',
    plate: 'XYZ9W87',
    mileage: 22000,
    vin: '94JXXXXXXXXXXXXXX',
    createdAt: '2023-03-22T15:00:00Z',
  },
  {
    id: 'v3',
    clientId: 'c3',
    brand: 'Fiat',
    model: 'Fiorino Endurance',
    year: 2022,
    engine: '1.4 EVO',
    fuel: 'Flex',
    plate: 'LOG0A01',
    mileage: 85000,
    vin: '9BDXXXXXXXXXXXXXX',
    createdAt: '2023-06-10T09:30:00Z',
  },
]

export const mockServiceOrders: ServiceOrder[] = [
  {
    id: 'os1',
    number: 'OS-2847',
    clientId: 'c1',
    vehicleId: 'v1',
    status: 'executando',
    mechanicId: 'm1',
    items: [
      {
        id: 'i1',
        description: 'Óleo Sintético 5W30 (Litro)',
        quantity: 4,
        unitPrice: 65.0,
        type: 'part',
      },
      {
        id: 'i2',
        description: 'Filtro de Óleo',
        quantity: 1,
        unitPrice: 45.0,
        type: 'part',
      },
      {
        id: 'i3',
        description: 'Mão de obra - Troca de óleo',
        quantity: 1,
        unitPrice: 120.0,
        type: 'service',
      },
    ],
    notes: 'Cliente relatou barulho na suspensão dianteira direita. Verificar.',
    total: 425.0,
    createdAt: new Date(Date.now() - 86400000 * 2).toISOString(),
    updatedAt: new Date(Date.now() - 3600000).toISOString(),
    expectedCompletion: new Date(Date.now() + 86400000).toISOString(),
  },
  {
    id: 'os2',
    number: 'OS-2848',
    clientId: 'c2',
    vehicleId: 'v2',
    status: 'aguardando',
    mechanicId: 'm3',
    items: [
      {
        id: 'i4',
        description: 'Bateria Moura 60Ah',
        quantity: 1,
        unitPrice: 480.0,
        type: 'part',
      },
      {
        id: 'i5',
        description: 'Diagnóstico Elétrico',
        quantity: 1,
        unitPrice: 150.0,
        type: 'service',
      },
    ],
    notes: 'Veículo não dá partida. Bateria parece descarregada.',
    total: 630.0,
    createdAt: new Date(Date.now() - 3600000 * 4).toISOString(),
    updatedAt: new Date(Date.now() - 3600000 * 4).toISOString(),
  },
  {
    id: 'os3',
    number: 'OS-2849',
    clientId: 'c3',
    vehicleId: 'v3',
    status: 'em_analise',
    mechanicId: 'm2',
    items: [],
    notes: 'Revisão preventiva de 80.000km. Checar freios e correia dentada.',
    total: 0,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
]

export const mockInventory: InventoryItem[] = [
  {
    id: 'inv1',
    name: 'Óleo Sintético 5W30',
    sku: 'OL-5W30-1L',
    supplier: 'Distribuidora Lubrax',
    costPrice: 35.0,
    sellPrice: 65.0,
    quantity: 45,
    minQuantity: 20,
    location: 'Corredor A - Prat 1',
  },
  {
    id: 'inv2',
    name: 'Filtro de Óleo Universal',
    sku: 'FO-UNIV-01',
    supplier: 'AutoPeças SP',
    costPrice: 15.0,
    sellPrice: 45.0,
    quantity: 12,
    minQuantity: 15,
    location: 'Corredor B - Prat 2',
  },
  {
    id: 'inv3',
    name: 'Pastilha de Freio Dianteira',
    sku: 'PF-DIA-01',
    supplier: 'AutoPeças SP',
    costPrice: 80.0,
    sellPrice: 160.0,
    quantity: 8,
    minQuantity: 10,
    location: 'Corredor C - Prat 1',
  },
]

export const mockTransactions: Transaction[] = [
  {
    id: 't1',
    description: 'OS-2845 - Troca de Pneus',
    amount: 1200.0,
    type: 'income',
    status: 'paid',
    dueDate: new Date().toISOString(),
    paidDate: new Date().toISOString(),
    category: 'Serviços',
  },
  {
    id: 't2',
    description: 'Aluguel Galpão',
    amount: 4500.0,
    type: 'expense',
    status: 'paid',
    dueDate: new Date(Date.now() - 86400000 * 5).toISOString(),
    paidDate: new Date(Date.now() - 86400000 * 5).toISOString(),
    category: 'Infraestrutura',
  },
  {
    id: 't3',
    description: 'OS-2846 - Revisão Completa',
    amount: 850.0,
    type: 'income',
    status: 'pending',
    dueDate: new Date(Date.now() + 86400000 * 2).toISOString(),
    category: 'Serviços',
  },
]

export const mockAppointments: Appointment[] = [
  {
    id: 'a1',
    clientId: 'c1',
    vehicleId: 'v1',
    mechanicId: 'm1',
    date: new Date(Date.now() + 86400000).toISOString(),
    durationMinutes: 120,
    status: 'scheduled',
    notes: 'Revisão 50k',
  },
  {
    id: 'a2',
    clientId: 'c2',
    vehicleId: 'v2',
    mechanicId: 'm3',
    date: new Date(Date.now() + 86400000 * 2).toISOString(),
    durationMinutes: 60,
    status: 'confirmed',
    notes: 'Troca de bateria',
  },
]
